import messages from "../../locale/messages";


const validate = values => {

    const errors = {}

    if (!values?.amount || values?.amount.trim() == "") {
        errors.amount = messages.invalidWalletAmount;
    } else if ((values?.amount && isNaN(values?.amount)) || values?.amount == 0) {
        errors.amount = messages.invalidWalletAmount;
    }

    return errors
}

export default validate;